import { UserRoles } from "../AuthStore/types";

export enum CaseStatus {
  ACTIVE = "ACTIVE",
  DEACTIVE = "DEACTIVE",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
  ON_HOLD = "ON_HOLD",
  COMPLETED = "COMPLETED",
}

export enum ContactChoice {
  EMAIL = "EMAIL",
  PHONE = "PHONE",
  IN_PERSON = "IN_PERSON",
}

export interface Case {
  id: string;
  status: CaseStatus;
  type: string;
  subType: string;
  userProvince?: string;
  caseProvince: string;
  district?: string;
  description: string;
  language: string;
  budget: string;
  currency: string;
  contactChoice: ContactChoice[];
  ownerId: string;
  ownerRole: UserRoles;
  createDate: number;
  updateDate: number;
  rejectReason?: string;
}

export interface CaseStatistics {
  mostOfferedCases: string[];
  mostCaseCategories: {
    name: string;
    caseCount: number;
  }[];
  mostHandShakeCases: string[];
}

export interface CaseCategories {
  mainCategories: string[];
  subCategories: { [key: string]: string[] };
  lastUpdated?: number;
}

export enum CaseOrderBy {
  CREATE_DATE_ASC = "createDateAsc",
  CREATE_DATE_DESC = "createDateDesc",
  USER_PROVINCE_ASC = "userProvinceAsc",
  USER_PROVINCE_DESC = "userProvinceDesc",
  BUDGET_ASC = "budgetAsc",
  BUDGET_DESC = "budgetDesc",
  CASE_TYPE_ASC = "caseTypeAsc",
  CASE_TYPE_DESC = "caseTypeDesc",
}
